export class MediaItemModel {

  /**
   * Constructor
   *
   * @param {string} name
   * @param {string} file
   * @param {string} type
   * @param {string} link
   * @param {string} iHash
   * @param {string} source
   * @param {string} embedded_link
   */
  public constructor(
    public name: string = null,
    public file: string = null,
    public type: string = null,
    public link: string = null,
    public iHash: string = null,
    public source: string = null,
    public embedded_link: string = null,
  ) { }
}